export { NAME as DMS_MODULE } from '../constants';

export const NAME = 'Zapujcka';
export const CRUMB_LABEL_KEY = 'edtZapujcka';
export const PREHLED_DOKLADU = 'PrehledDokladu';
export const POLOZKY = 'Polozky';

export const MILISEKUNDY_DEN = 24 * 60 * 60 * 1000;
export const INTERVAL = 4; // zaokrouhluje se na ctvrtiny dne

export const DEPENDENT_TABLES = <const>[
	PREHLED_DOKLADU,
	POLOZKY,
];

export enum PredmetZapujckyEnum {
	VOZIDLO,
	PREDMET
}

export enum ZAPUJCKA_STAV {
	OTEVRENE = 0,
	PUJCENE = 1,
	VRACENE = 2,
	ODEPSANE = 3,
	FAKTUROVANE = 4,
	DLPUJCKA = 5,
}

export type DependentTableNames = typeof DEPENDENT_TABLES[number];

export enum NAJEMNI_SMLOUVA_TYP {
	ORIGINAL,
	KOPIE_PREDANI,
	KOPIE_PREVZETI,
}
